/**
 * replaceCustomReviews
 *
 * This function replaces the default product review stars with custom styled stars after a delay.
 * It finds all review containers, gets the rating number from the aria-label attribute,
 * sets the rating text, and shows the custom stars.
 */
let counterReviewsContainer = 0;

function replaceCustomReviews() {
  const reviewsContainers = document.querySelectorAll(".kl_reviews__star_rating_widget");
  const reviewsHeading = document.querySelector('[data-name="reviews-heading"]');
  const label = document.querySelector(".kl_reviews__star_rating_widget__label");
  if (!label) return;

  if (reviewsHeading && label.textContent) {
    reviewsHeading.textContent = "(" + label.textContent + ")";
  }

  reviewsContainers.forEach((review) => {
    const regex = /([0-9]+[.,]?[0-9]*)/;
    let text = review.getAttribute("aria-label");
    let match = text.match(regex);
    if (!match) return;
    let rating = match[1].replace(',', '.');
    const childSpan = document.createElement('span');
    childSpan.textContent = Number(rating).toFixed(2);
    childSpan.classList.add("kl_reviews__star_rating_widget__label");
    review.querySelector(".kl_reviews__star_rating_widget__label").parentElement.appendChild(childSpan);
    childSpan.classList.add("show");
    review.addEventListener('click', () => document.querySelector('[data-value="accordion-reviews"]').classList.add("active"));
  });
}

function safeReplaceCustomReviews() {
  const tryInsert = () => {
    const label = document.querySelector(".kl_reviews__star_rating_widget__label");
    if (label) { // nie sprawdzamy już tekstu!
      replaceCustomReviews();
      return true;
    }
    return false;
  };

  if (tryInsert()) return;

  const observer = new MutationObserver(() => {
    if (tryInsert()) observer.disconnect();
  });

  observer.observe(document.body, { childList: true, subtree: true });
}

// Wywołaj zamiast replaceCustomReviews();
safeReplaceCustomReviews();

function observeRatingWrapper() {
  const observer = new MutationObserver(function (mutations, observerInstance) {
    if (document.querySelector('.kl_reviews__reviews_list')) {
      // replaceCustomReviews(); // This line is removed as per the edit hint
      observerInstance.disconnect();
    }
  });
  observer.observe(document.querySelector(".accordion__content--reviews"), { childList: true, subtree: true });
}
observeRatingWrapper();

// Function to check if reviews accordion should be hidden or shown
function hideReviewsAccordionIfEmpty() {
  const reviewsWrapper = document.querySelector("#klaviyo-product-reviews-wrapper");

  if (reviewsWrapper) {
    if (reviewsWrapper.innerHTML !== "") {
      document.querySelector('[data-value="accordion-reviews"]').removeAttribute("hidden");
    }
  } else {
    counterReviewsContainer++;
    if (counterReviewsContainer < 20) {
      observeReviewsContainer(); // Continue observing if element not found
    }
  }
}

function observeReviewsContainer() {
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (document.querySelector("#klaviyo-product-reviews-wrapper")) {
        hideReviewsAccordionIfEmpty();
      }
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true // Ensure it catches nested elements being added
  });
}
observeReviewsContainer();

function addCustomRatingToWidget(widget) {
  if (widget.querySelector('.custom-klaviyo-rating-label')) return;

  const label = widget.querySelector('.kl_reviews__star_rating_widget__label');
  if (label) {
    let text = widget.getAttribute("aria-label") || '';
    // Uniwersalny regex: pierwsza liczba w aria-label
    let match = text.match(/([0-9]+[.,]?[0-9]*)/);
    if (!match) return;
    let rating = match[1].replace(',', '.');
    const childSpan = document.createElement('span');
    childSpan.textContent = Number(rating).toFixed(2);
    childSpan.classList.add("custom-klaviyo-rating-label");
    label.parentElement.appendChild(childSpan);
    childSpan.classList.add("show");
  }
}